<script setup lang="ts">
  import { PageContainer } from '@/shared/ui/components'

  import { AllocateCoinsForm } from '@/features/coins/allocate'
  import { WithdrawCoinsForm } from '@/features/coins/withdraw'

  definePage({
    meta: {
      layout: 'baseNew',
      adminRoute: true,
    },
  })

  const currentTab = ref<'allocate' | 'withdraw'>('allocate')
</script>

<template>
  <PageContainer
    :title="$t('profiles_balance_management')"
    class="allocate-coins-page p-6"
  >
    <QTabs
      v-model="currentTab"
      no-caps
      class="allocate-coins-page__tabs mb-10"
      align="left"
    >
      <QTab
        name="allocate"
        :label="$t('profiles_allocate_coins')"
      />
      <QTab
        name="withdraw"
        :label="$t('profiles_withdraw_coins')"
      />
    </QTabs>
    <div class="w-full">
      <QTabPanels
        v-model="currentTab"
        class="allocate-coins-page__tab-panels bg-transparent"
      >
        <QTabPanel name="allocate">
          <AllocateCoinsForm />
        </QTabPanel>
        <QTabPanel name="withdraw">
          <WithdrawCoinsForm />
        </QTabPanel>
      </QTabPanels>
    </div>
  </PageContainer>
</template>

<style lang="scss" scoped>
  .allocate-coins-page {
    &__tabs {
      :deep() {
        .q-tab {
          &__label {
            @include font-montserrat-500(14px, 24px, var(--component-allocate-coins-tabs-item-content-color));
          }
          &__indicator {
            background-color: var(--component-allocate-coins-tabs-item-indicator-color);
          }
          &--inactive {
            opacity: 1;
          }
          &--active {
            .q-tab {
              &__label {
                color: var(--component-allocate-coins-tabs-item-active-content-color);
              }
            }
          }
        }
      }
    }
    &__tab-panels {
      :deep() {
        .q-tab-panel {
          padding: 0;
        }
      }
    }
  }
</style>
